import React, { useMemo } from 'react';
import { FormItem, FormValidateTextAndNumber } from 'components/Form2';
import {
  GridFormAccount,
  GridFormAccount1to2,
  GridFormAccount2to3,
} from 'page/Application/MyPage/component/FormMyPage/styled';
import LabelFormMyPage from 'page/Application/MyPage/component/FormMyPage/LabelFormMyPage';
import { SelectStyled } from 'components/Form2/FormEmailSelectDomain/styled';
import { getListDutyExisted } from 'api/account/account.api';
import useCustomQuery from 'hook/useQuery/useCustomQuery';
import useMultiLanguageRegisterAccount from 'page/Application/ManageAccountSoliton/RegisterAccountSoliton/hook/useMultiLanguageRegisterAccount';

const DepartmentPositionDuty = ({ editMode }) => {
  const { useQueryWithoutParams } = useCustomQuery();
  const {
    REGISTER_ACCOUNT_PLACEHOLDER_DEPARTMENT,
    REGISTER_ACCOUNT_PLACEHOLDER_POSITION,
  } = useMultiLanguageRegisterAccount();

  const { data: listDuty = [] } = useQueryWithoutParams({
    api: getListDutyExisted,
    key: 'listDuty',
    options: {
      refetchOnWindowFocus: false,
    },
  });

  const dutyOptions = useMemo(() => {
    return listDuty?.data?.map((value) => ({
      label: value?.name,
      title: '',
      value: value?.id,
    }));
  }, [listDuty?.data]);
  return (
    <GridFormAccount>
      <GridFormAccount1to2>
        <LabelFormMyPage labelText={'部署'} />
      </GridFormAccount1to2>
      <GridFormAccount2to3>
        <FormValidateTextAndNumber
          name="department"
          required={false}
          placeholder={editMode && REGISTER_ACCOUNT_PLACEHOLDER_DEPARTMENT}
        />
      </GridFormAccount2to3>

      <GridFormAccount1to2>
        <LabelFormMyPage labelText={'役職'} />
      </GridFormAccount1to2>

      <GridFormAccount2to3>
        <FormValidateTextAndNumber
          name="position"
          required={false}
          placeholder={editMode && REGISTER_ACCOUNT_PLACEHOLDER_POSITION}
        />
      </GridFormAccount2to3>

      <GridFormAccount1to2>
        <LabelFormMyPage labelText={'職務'} />
      </GridFormAccount1to2>
      <GridFormAccount2to3>
        <FormItem name={'dutyId'}>
          <SelectStyled options={dutyOptions} />
        </FormItem>
      </GridFormAccount2to3>
    </GridFormAccount>
  );
};

export default DepartmentPositionDuty;
